/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef } from 'react';

import classNames from 'classnames';

import UserSearchSuggestion from './UserSearchSuggestion';
import Tooltip from '../../Tooltip';

import classes from './styles.module.scss';
import useOnClickOutside from '../../../hooks/useOnClickOutside';

export default function RoundedInput({
  value,
  label,
  errors,
  isTouched,
  users,
  readOnly,
  style,
  canCreateUser,
  onCreateUserRequest,
  readOnlyTooltip,
  requireSuggestionSelection,
  onValidationChange,
  ...props
}) {
  const [isUserSearchSuggestionVisible, setIsUserSearchSuggestionVisible] =
    useState(true);

  // Track validated emails when requireSuggestionSelection is enabled
  const [validatedEmails, setValidatedEmails] = useState(new Set());

  // Check if all current emails are validated
  const checkEmailValidation = (currentValue) => {
    if (!requireSuggestionSelection || !currentValue) return true;

    const emails = currentValue.split(';').map(email => email.trim()).filter(email => email);
    return emails.every(email => validatedEmails.has(email));
  };

  // Update validation state when value or validatedEmails change
  React.useEffect(() => {
    if (requireSuggestionSelection && onValidationChange) {
      const isValid = checkEmailValidation(value);
      onValidationChange(isValid);
    }
  }, [value, validatedEmails, requireSuggestionSelection, onValidationChange]);

  const roundedInputRef = useRef();
  useOnClickOutside(roundedInputRef, () => {
    setIsUserSearchSuggestionVisible(false);
  });

  const inputWrapper = (
    <div
      className={classNames(classes.RoundedInput, {
        [classes.readOnly]: readOnly,
      })}
      ref={roundedInputRef}
    >
      <input
        onFocus={(event) => {
          if (readOnly) {
            event.target.blur();
          }

          setIsUserSearchSuggestionVisible(true);
        }}
        // onBlur={() => {
        //   setTimeout(() => {
        //     setIsUserSearchSuggestionVisible(false);
        //   }, 200);
        // }}
        className={classNames(
          value && classes.active,
          errors && isTouched && classes.error
        )}
        value={value}
        readOnly={readOnly}
        style={style}
        {...props}
      />
      <label>{label}</label>
      {isUserSearchSuggestionVisible && users && (
        <UserSearchSuggestion
          value={value}
          setValue={props.setValue}
          setIsUserSearchSuggestionVisible={setIsUserSearchSuggestionVisible}
          canCreateUser={canCreateUser}
          onCreateUserRequest={onCreateUserRequest}
          requireSuggestionSelection={requireSuggestionSelection}
          onSuggestionSelected={(email) => {
            if (requireSuggestionSelection) {
              setValidatedEmails(prev => new Set([...prev, email]));
            }
          }}
        />
      )}
    </div>
  );

  // Wrap with tooltip if readOnly and tooltip text is provided
  if (readOnly && readOnlyTooltip) {
    return (
      <Tooltip text={readOnlyTooltip} position="bottom">
        {inputWrapper}
      </Tooltip>
    );
  }

  return inputWrapper;
}
